module.exports = __webpack_public_path__ + "static/media/terkirim.fb75bb81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/terkirim.svg
// module id = 31
// module chunks = 1